import { useEffect, useState } from 'react';

import { getImageRatio } from 'containers/world/utils';

import './popup.infoBox.scss';
import { CChartPie } from '@coreui/react-chartjs';

const EXPAND_WIDTH = 60;

function PopupDashboard(props) {
  const [imgRatio, setImgRatio] = useState(1);
  // eslint-disable-next-line
  const { title, text, imageUrl, readMoreURL } = props.media;
  // eslint-disable-next-line
  const [isExpanded, setIsExpanded] = useState(false);
  // eslint-disable-next-line
  const [showExpand, setShowExpand] = useState(false);
  // eslint-disable-next-line
  const [descriptionWidth, setDescriptionWidth] = useState(0);
  // eslint-disable-next-line
  const [truncateWidth, setTruncateWidth] = useState(0);
  // eslint-disable-next-line
  const [popupHeight, setPopupHeight] = useState(0);
  const [flex, setFlex] = useState('center');

  useEffect(() => {
    getImageRatio(imageUrl)
      .then((result) => {
        setImgRatio(result);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [imageUrl]);

  useEffect(() => {
    if (!descriptionWidth || !truncateWidth) return;
    const threshold = truncateWidth + EXPAND_WIDTH;
    setShowExpand(threshold >= descriptionWidth);
  }, [descriptionWidth, truncateWidth]);

  useEffect(() => {
    if (popupHeight && popupHeight > window.innerHeight) {
      setFlex('flex-start');
    } else setFlex('center');
  }, [popupHeight]);

  console.log(imgRatio);

  return (
    <div
      className="Popup-content Popup-content-infobox"
      style={{ alignItems: flex }}
    >
      {/* <CChartDoughnut
        datasets={[
          {
            backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
            data: [40, 20, 80, 10],
          },
        ]}
        labels={['VueJs', 'EmberJs', 'ReactJs', 'AngularJs']}
        options={{
          tooltips: {
            enabled: true,
          },
        }}
      /> */}

      <CChartPie
        className="pie-chart"
        datasets={[
          {
            backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
            data: [40, 20, 80, 10],
            borderWidth: 0,
          },
        ]}
        labels={['VueJs', 'EmberJs', 'ReactJs', 'AngularJs']}
        options={{
          tooltips: {
            enabled: true,
          },
          responsive: true,
          maintainAspectRatio: false,
        }}
      />
    </div>
  );
}

export default PopupDashboard;
